import  {Outlet } from 'react-router-dom';
import './App.css'
import Nav from './Components/Nav';
import Footer from './Components/Footer';
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";

// O componente App é responsável por renderizar a navegação, o conteúdo principal e o rodapé da aplicação.
const App = () => (
  <>
    <ScrollToTop /> {/* Rola a página para o topo quando a rota muda */}
    {/* O componente Nav renderiza a barra de navegação da aplicação */}
    {/* O Outlet renderiza o conteúdo principal da rota correspondente */}
    {/* O Footer renderiza o rodapé da aplicação */} 
    <Nav /> {/* Renderiza o componente de navegação */}
    <Outlet /> {/* Renderiza o conteúdo principal da rota */}
    <Footer /> {/* Renderiza o rodapé da aplicação */}
  </>
);

export default App; // Exporta o componente App por padrão